import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {ColorConfig, ColorConfigJson} from './color-config';
import {FontConfig, FontConfigJson} from './font-config';
import {BorderConfig, BorderConfigJson} from './border-config';
import {PressureStepSizeConfig, PressureStepSizeConfigJson} from './pressure-step-size-config';
import {TimeStepSizeConfig, TimeStepSizeConfigJson} from './time-step-size-config';
import {PressureThresholdConfig, PressureThresholdConfigJson} from './pressure-threshold-config';
import {LivePressureStepSizeConfig, LivePressureStepSizeConfigJson} from './live-pressure-step-size-config';

export type PressureGraduationsConfigJson = {
  timeStepSize: TimeStepSizeConfigJson;
  pressureStepSize: PressureStepSizeConfigJson;
  livePressureStepSize: LivePressureStepSizeConfigJson;
  color: ColorConfigJson;
  outOfRangeColor: ColorConfigJson;
  font: FontConfigJson;
  lines: BorderConfigJson;
  pressureThreshold: PressureThresholdConfigJson;
};

export class PressureGraduationsConfig implements JsonConfigInterface<PressureGraduationsConfigJson> {

  public readonly timeStepSize: TimeStepSizeConfig = new TimeStepSizeConfig();
  public readonly pressureStepSize: PressureStepSizeConfig = new PressureStepSizeConfig();
  public readonly livePressureStepSize: LivePressureStepSizeConfig = new LivePressureStepSizeConfig();
  public readonly color: ColorConfig = new ColorConfig();
  public readonly outOfRangeColor: ColorConfig = new ColorConfig();
  public readonly font: FontConfig = new FontConfig();
  public readonly lines: BorderConfig = new BorderConfig();
  public readonly pressureThreshold: PressureThresholdConfig = new PressureThresholdConfig();

  constructor(json?: PressureGraduationsConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public deserializeJson(json: PressureGraduationsConfigJson): void {
    this.timeStepSize.deserializeJson(json.timeStepSize);
    this.pressureStepSize.deserializeJson(json.pressureStepSize);
    this.livePressureStepSize.deserializeJson(json.livePressureStepSize);
    this.color.deserializeJson(json.color);
    this.outOfRangeColor.deserializeJson(json.outOfRangeColor);
    this.font.deserializeJson(json.font);
    this.lines.deserializeJson(json.lines);
    this.pressureThreshold.deserializeJson(json.pressureThreshold);
  }
}
